import useAlertQuery from "@/query/alert-query";
import MenuButton from "./menu-button";

const MenuAlert: React.FC<{
  route: string;
  label: string;
  icon: string;
}> = ({ route, label, icon }) => {
  const { data: alertData, isLoading } = useAlertQuery();

  if (!alertData && isLoading) return <></>;
  if (
    route === "/alert" &&
    (!alertData || Object.keys(alertData).length === 0)
  ) {
    return <></>; // Alert menu item skip if empty
  }

  return (
    <MenuButton route={route} icon={icon}>
      {label}
    </MenuButton>
  );
};

export default MenuAlert;
